import type { Breadcrumb } from '../types.js';

export interface BreadcrumbBuffer {
  add(b: Breadcrumb): void;
  snapshot(): Breadcrumb[];
  clear(): void;
}

export function createBreadcrumbBuffer(maxSize: number): BreadcrumbBuffer {
  const buffer: Breadcrumb[] = [];
  return {
    add(b: Breadcrumb): void {
      buffer.push(b);
      while (buffer.length > maxSize) buffer.shift();
    },
    snapshot(): Breadcrumb[] {
      return buffer.slice();
    },
    clear(): void {
      buffer.length = 0;
    },
  };
}
